module.exports = __webpack_public_path__ + "img/3.a6a4f4b.svg";